'use client';

import classNames from 'classnames';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import TrailStandardCardShimmer from '@alltrails/cards/components/TrailStandardCard/TrailStandardCardShimmer';
import styles from './styles.module.scss';

type TrailCarouselShimmerProps = {
  className?: string;
};

const TrailCarouselShimmer = ({ className }: TrailCarouselShimmerProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <ShimmerContainer>
        <div className={styles.titleShimmer} />
      </ShimmerContainer>
      <div className={styles.cardsContainer}>
        {Array.from({ length: 4 }).map((_, index) => (
          <TrailStandardCardShimmer key={index} className={styles.cardShimmer} />
        ))}
      </div>
    </div>
  );
};

export default TrailCarouselShimmer;
